export const b2bUrl =
  process.env.NEXT_PUBLIC_B2B_URL || 'https://primarycare.lamimed.it';

export const capsulaUrl =
  process.env.NEXT_PUBLIC_CAPSULA_URL || 'https://capsula.app';
